<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_pa2"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="prepaidRecords_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="getLimit('prepaidRecords_refresh_button')"
          @click="updateShipperPrepaidResult()"
        >
          更新状态
        </el-button>
        <el-button
          v-if="getLimit('prepaidRecords_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      show-footer
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运输单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isMonthlyOrder"
          title="结算类型"
          min-width="100"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMonthlyOrder"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.isMonthlyOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payStatus"
          title="预付状态"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payStatus')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.payStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.payStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="failReasons"
          title="失败原因"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.failReasons"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="serialNumber"
          title="预付流水号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.serialNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerName"
          title="付款人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerPhone"
          title="付款人手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeName"
          title="收款人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeePhone"
          title="收款人手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeePhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payType"
          title="支付类型"
          :formatter="formatterPayType"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.payType" clearable placeholder="请选择">
            <el-option
              v-for="item in payTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="amount"
          title="金额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.amountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.amountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paySource"
          title="支付来源"
          :formatter="formatterPaySource"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.paySource"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in paySourceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createdName"
          title="操作人员"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdName"
            placeholder="请输入操作人员"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="prepaidRecords_refresh_button && scope.row.payStatus == 1"
            class="item"
            effect="dark"
            content="更新预付结果"
            placement="top"
          >
            <vxe-button type="text" @click="handleRefresh(scope.row)">
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="prepaidRecords_again_button && scope.row.payStatus == -1"
            class="item"
            effect="dark"
            content="重新预付"
            placement="top"
          >
            <vxe-button type="text" @click="handleAgain(scope.row.code)">
              <i class="el-icon-coin" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getLimit } from "@/utils/getLimit.js";
import {
  payAdvanceYuList,
  queryShipperPrepaidResult
} from "@/api/CustomerService";
import { queryPayAdvanceStatus, centralPrepaymentAgain } from "@/api/transport";

export default {
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-tms-api/payAdvance/exportPrePayRecords", //导出接口
        name: "预付记录"
      },
      loading: false,
      prepaidRecords_search_button: false,
      prepaidRecords_refresh_button: false,
      prepaidRecords_again_button: false,
      tableData: [],
      parentData: {
        payStatusOptions: [
          { label: "预付失败", value: -1 },
          { label: "待付款", value: 0 },
          { label: "付款中", value: 1 },
          { label: "已完成", value: 2 }
        ]
      },
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      payTypeOptions: [
        {
          value: "1",
          label: "油点支付"
        },
        {
          value: "2",
          label: "线下加油站"
        },
        {
          value: "3",
          label: "转账支付"
        },
        {
          value: "4",
          label: "余额支付"
        },
        {
          value: "6",
          label: "平台余额支付"
        },
        {
          value: "10",
          label: "银行支付"
        },
        {
          value: "11",
          label: "在线支付"
        }
      ],
      paySourceOptions: [
        {
          value: "platform",
          label: "平台支付"
        },
        {
          value: "shipment",
          label: "托运人支付"
        }
      ],
      sumObject: {
        amount: 0
      },
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.findList();
    this.prepaidRecords_search_button = getLimit(
      "prepaidRecords_search_button"
    );
    this.prepaidRecords_refresh_button = getLimit(
      "prepaidRecords_refresh_button"
    );
    this.prepaidRecords_again_button = getLimit("prepaidRecords_again_button");
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        payAdvanceYuList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    updateShipperPrepaidResult() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (selectRecords.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
      } else if (selectRecords.length > 20) {
        this.$message({ message: "批量处理最多20条数据", type: "warning" });
      } else {
        const arrcarcode = selectRecords.map(item => {
          return item.code;
        });
        const rLoading = this.openLoading();
        let codes = arrcarcode.join(",");
        queryShipperPrepaidResult({ codes }).then(res => {
          this.$message({ message: res.msg, type: "success" });
          this.findList();
          rLoading.close();
        });
      }
    },
    async handleRefresh(item) {
      // let checkedRowArray = item?[item]:this.$refs.xTable.getCheckboxRecords();
      // if (!checkedRowArray || checkedRowArray.length === 0) {
      //   this.$message.warning("请选择需要更新的项");
      //   return false;
      // } else if (checkedRowArray.length > 20) {
      //   this.$message.warning("批量处理最多20条数据");
      //   return false;
      // }
      // let branchCode = checkedRowArray[0].branchCode;
      // let codes = [];
      // for (let subItem of checkedRowArray) {
      //   if (subItem.branchCode != branchCode) {
      //     this.$message.warning("请选择同一机构");
      //     return false;
      //   }
      //   if (subItem.payStatus != 1) {
      //     this.$message.warning("当前预付状态已更新");
      //     return false;
      //   }
      //   codes.push(subItem.code);
      // }
      // codes = codes.join(',')

      // 等于11 云企付 否则 集中支付接口
      const rLoading = this.openLoading();
      let response =
        item.payType == 11
          ? await queryShipperPrepaidResult({ codes: item.code })
          : await queryPayAdvanceStatus({ codes: item.code });
      rLoading.close();
      this.$message.success(response.msg);
      this.findList();
    },
    async handleAgain(code) {
      const rLoading = this.openLoading();
      let response = await centralPrepaymentAgain({ code });
      rLoading.close();
      this.$message.success(response.msg);
      this.findList();
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item1 => item1.code === cellValue);
      return item ? item.groupName : "";
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    },
    // 状态
    formatterPayType({ cellValue }) {
      const item = this.payTypeOptions.find(item1 => item1.value === cellValue);
      return item ? item.label : "";
    },
    // 支付来源
    formatterPaySource({ cellValue }) {
      const item = this.paySourceOptions.find(
        item1 => item1.value === cellValue
      );
      return item ? item.label : "";
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "amount") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    }
  }
};
</script>

<style></style>
